import { types } from "api";
import { parseUTCDate } from "helpers/date";

export type Status = "In Progress" | "Completed" | "Scheduled";

export interface Assignment extends types.Assignment {
	status: Status;
}

/**
 * Returns the status of an assignment.
 * @param assignment The assignment to get the status of.
 * @param now The current date. This is for testing.
 */
export const getStatus = (
	assignment: types.Assignment | Assignment,
	now = new Date(),
): Status => {
	const start = parseUTCDate(assignment.startDate);
	const end = parseUTCDate(assignment.endDate);

	if (now >= start && now <= end) {
		return "In Progress";
	}

	if (now > parseUTCDate(assignment.endDate)) {
		return "Completed";
	}

	return "Scheduled";
};
